import { createStore } from 'redux';
import rootReducer from './modules';

export default () => {
  // console.log(process.env.NODE_ENV);
  // const devtools = process.env.NODE_ENV === 'development' ? (window.devToolsExtension && window.devToolsExtension()) : f => f;
  // return createStore(rootReducer, devtools)
  return createStore(rootReducer);
};
